import { CommonWidthEnum } from 'common/constants/commonWidth'
import { ContentWidthEnum } from 'common/types/styleTypes'

export const convertContentWidthToCommonWidth = (
  contentWidth: ContentWidthEnum,
) => {
  switch (contentWidth) {
    case ContentWidthEnum.xs:
      return CommonWidthEnum.extraSmall
    case ContentWidthEnum.s:
      return CommonWidthEnum.small
    case ContentWidthEnum.m:
      return CommonWidthEnum.medium
    case ContentWidthEnum.l:
      return CommonWidthEnum.wide
    case ContentWidthEnum.xl:
      return CommonWidthEnum.fullPage
  }
}
